import styled from "styled-components";

/** Chip de filtro da barra das listas (redesign V3). `$on` = selecionado. */
export const ChipButton = styled.button<{ $on?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid ${(p) => (p.$on ? "#202124" : "#dadce0")};
  background: ${(p) => (p.$on ? "#202124" : "#ffffff")};
  color: ${(p) => (p.$on ? "#ffffff" : "#3c4043")};
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;

  &:hover {
    background: ${(p) => (p.$on ? "#202124" : "#f1f3f4")};
  }
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    display: inline-block;
  }
`;

export const ChipGroupLabel = styled.span`
  font-family: var(--font-sans);
  font-size: 12px;
  font-weight: 500;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin: 0 4px 0 6px;
`;

export const ToolbarDivider = styled.span`
  width: 1px;
  height: 24px;
  background: #e2e6ea;
  flex-shrink: 0;
`;

/** Botão tonal das linhas ("Gerenciar", "Abrir relatório"). */
export const TonalButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 0;
  background: var(--brand-50);
  color: var(--brand-700);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: var(--brand-100);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .material-icons {
    font-size: 18px;
  }
`;

/** Botão-alternador quadrado das automações (postagens, respostas de IA). */
export const AutomationToggle = styled.button<{ $on: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid ${(p) => (p.$on ? "#d6e4f7" : "#dadce0")};
  background: ${(p) => (p.$on ? "var(--brand-50)" : "#ffffff")};
  color: ${(p) => (p.$on ? "var(--brand-700)" : "var(--text-muted)")};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s;

  &:hover {
    background: ${(p) => (p.$on ? "var(--brand-100)" : "#f1f3f4")};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .material-icons {
    font-size: 20px;
  }
`;

/** Botão cheio do cabeçalho das listas ("Pegar acesso de cliente novo", "Novo usuário"). */
export const FilledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  border: 0;
  background: var(--brand);
  color: #ffffff;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, box-shadow 0.15s;

  &:hover {
    background: var(--brand-700);
    box-shadow: 0 1px 3px rgba(18, 100, 199, 0.4), 0 4px 12px rgba(18, 100, 199, 0.25);
  }
  .material-icons {
    font-size: 20px;
  }
`;

export const OutlinedButton = styled(FilledButton)`
  background: #ffffff;
  color: var(--brand-700);
  border: 1px solid #dadce0;
  &:hover {
    background: #f8fafd;
    border-color: #c2d7f5;
    box-shadow: none;
  }
`;
